<template>
  <div class="section-abstract-header">Contacts</div>
  <div class="section-abstract mb-1">
    <v-row class="ma-0 abstract-row" @click="openSection('SectionEtablissementRepresentantExtend', 'etablissement', false)">
      <v-col>
        <div v-if="etablissement.representantId <= 0" class="section-abstract-title">Ajouter un Responsable légal</div>
        <div v-else class="section-abstract-title">Responsable légal</div>

        <div  v-if="representantId > 0">
          <div class="section-abstract-grid" style="display:grid; grid-template-columns: repeat(1, minmax(0, 1fr)); column-gap: 16px; row-gap: 0; align-items: start;">
            <div class="section-abstract-cell" style="grid-row: 1 / span 1; grid-column: 1 / span 1;">
              <div class="section-abstract-value">{{ representant.prenom }} {{ representant.nom }} <v-icon class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(representant.prenom + ' ' + representant.nom, 0)">{{ copiedField === 0 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
            </div>

            <div class="section-abstract-cell" style="grid-row: 2 / span 1; grid-column: 1 / span 1;">
              <div class="section-abstract-value">{{ representant.mail }} <v-icon class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(representant.mail, 1)">{{ copiedField === 1 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
            </div>
            <div class="section-abstract-cell" style="grid-row: 3 / span 1; grid-column: 1 / span 1;">
              <div class="section-abstract-value">{{ representant.numero }} <v-icon class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(representant.numero, 2)">{{ copiedField === 2 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
            </div>
          </div>
        </div>

      </v-col>
      <v-col cols="1" style=" align-content: center; align-items: center">
        <v-icon class="arrow-icon" style="font-size: 12px; color: #25A3A7;">
          fas fa-chevron-right
        </v-icon>
      </v-col>
    </v-row>
  </div>
</template>


<script lang="ts">
  import { defineComponent } from "vue";
  import SectionEtablissementRepresentantAbstract from '@/generated/sections/SectionEtablissementRepresentantAbstract.vue';
  import {FwkButtons, FwkSections, RessourceFwkButton, RessourceFwkSection} from "@/ressources/globalRessources.ts";
  import {GenSection, RessourceGenSection} from "@/generated/ressources/generatedRessources.ts";
  import {storeContact} from "@/generated/stores";
  export default defineComponent({
    extends: SectionEtablissementRepresentantAbstract,
    components: {},
    computed: {
      representant () {
        if (this.representantId > 0) {
          return storeContact.getContact(this.representantId);
        } else {
          return null
        }
      },
    },
  })
</script>
